'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GoogleButton = undefined;

var _GoogleButton2 = require('./GoogleButton');

var _GoogleButton3 = _interopRequireDefault(_GoogleButton2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GoogleButton = _GoogleButton3.default;
exports.default = _GoogleButton3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-google-button/lib/index.js
// module id = 446
// module chunks = 0